/*
 * AnimatedRain
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';

export type AnimatedRainProps = {
  imgSrc: string,
  dropRef: React$ElementRef<*>,
  canvasRef: React$ElementRef<*>,
};

const AnimatedRainWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const AnimatedRainDrop = styled.img`
  display: none;
`;

/**
 * AnimatedRain React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.imgSrc] - drop image source
 * @param {React$ElementRef<*>} [props.dropRef] - reference to drop image DOM node
 * @param {React$ElementRef<*>} [props.canvasRef] - reference to canvas DOM node
 * @example <caption>Simple usage</caption>
 * <AnimatedRain width={200} height={200} />
 * @returns {React.Node<*>} React-component
 */
export const AnimatedRain = ({
  imgSrc,
  dropRef,
  canvasRef,
}: AnimatedRainProps) => (
  <AnimatedRainWrapper>
    <canvas ref={canvasRef} />
    <AnimatedRainDrop ref={dropRef} src={imgSrc} />
  </AnimatedRainWrapper>
);
